import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseValidationResult } from "@ha/ui/forms";
import { Observable } from "rxjs";

import { PermitRequest } from "../../shared/models/permit-request.model";
import { PermitListItem } from "../models/permit-list-item.model";
import { PreparedPermitListItem } from "../models/prepared-permit-list-item.model";

@Injectable({ providedIn: "root" })
export class PermitListService {
    constructor(private httpClient: HttpClient) {}

    public getAll(): Observable<PermitListItem[]> {
        return this.httpClient.get<PermitListItem[]>("/api/PermitList/GetAll");
    }

    public getAllCompleted(skip: number = 0, take: number = 50): Observable<PermitListItem[]> {
        return this.httpClient.get<PermitListItem[]>("/api/PermitList/GetAllCompleted", {
            params: { skip: skip.toString(), take: take.toString() },
        });
    }

    public getAllOngoing(includeAllInSubscription: boolean): Observable<PermitListItem[]> {
        return this.httpClient.get<PermitListItem[]>("/api/PermitList/GetAllOngoing", {
            params: { includeAllInSubscription },
        });
    }

    public getAllPlanned(): Observable<PermitListItem[]> {
        return this.httpClient.get<PermitListItem[]>("/api/PermitList/GetAllPlanned");
    }

    public getAllPrepared(): Observable<PreparedPermitListItem[]> {
        return this.httpClient.get<PreparedPermitListItem[]>("/api/PermitList/GetAllPrepared");
    }

    public getRetrievableFlammableAtexPermits(permitId: number): Observable<PreparedPermitListItem[]> {
        return this.httpClient.get<PreparedPermitListItem[]>("/api/PermitList/GetRetrievableFlammableAtexPermits", {
            params: { permitId },
        });
    }

    // Move this call to som other service?
    public claimPreparedPermit(permitId: number): Observable<BaseValidationResult> {
        return this.httpClient.put<BaseValidationResult>("/api/Permit/ClaimPreparedPermit", { permitId });
    }

    public connectStandaloneFlammableAtexPermit(
        hotWorkPermitId: number,
        flammableAtexPermitId: number,
    ): Observable<BaseValidationResult> {
        return this.httpClient.post<BaseValidationResult>("/api/Permit/ConnectStandaloneFlammableAtexPermit", {
            hotWorkPermitId,
            flammableAtexPermitId,
        });
    }

    public removePlannedPermit(permitId: number): Observable<BaseValidationResult> {
        return this.httpClient.delete<BaseValidationResult>("/api/Permit/RemovePlannedPermit", {
            params: { permitId },
        });
    }
}
